<template>
    <div>
        <h3 @click="back" style="border-bottom:1px solid #ccc;padding:0px 0 10px 10px;cursor:pointer">返回</h3>
        <div class="body" v-if="data.packageId!=null">
            <h2>创建时间：{{data.createTime}}</h2>
            <h2>支付时间：{{data.finishTime}}</h2>
            <h2>价格：{{data.price}}元</h2>
            <h2>订单编号：{{data.orderNo}}</h2>
            <h2>订单类型：{{data.packageId!=null?'套餐支付':'监测支付'}}</h2>
            <h2>套餐类型:{{package == null ? '':package.title}}</h2>
            <h2>套餐备注:{{package == null ? '':package.remark}}</h2>
        </div>

        <div class="body" v-show="data.packageId==null">
            <h2>创建时间：{{data.createTime}}</h2>
            <h2>支付时间：{{data.finishTime}}</h2>
            <h2>价格：{{data.price}}元</h2>
            <h2>订单编号：{{data.orderNo}}</h2>
            <h2>订单类型：{{data.packageId!=null?'套餐支付':'监测支付'}}</h2>
            <h2>作品添加时间:{{imgList!=null ? imgList[0].createDate:''}}</h2>
            <h2>监测作品：</h2>
            <div v-for="(item,key) in imgList" :key="key">
                <img  class="img" :src="item.link"/>
            </div>
        </div>
    </div>
</template>

<script>
import {orderDetailsApi} from '@/service/allApi'
export default {
    data(){
        return{
            data:null,
            imgList:null,
            package:null
        }
    },
    created(){
        var data =  this.$route.query.data
        this.data = JSON.parse(data)
        this.data.createTime = this.timestampToTime(JSON.parse(data).createTime)
        // console.log(this.data)
        this.orderDetails();
    },
    methods:{
        back(){
            window.history.back(-1); 
        },
        timestampToTime:function (value) {
            //var date = new Date(row.cjsj) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
            // console.log(value)
            var date = new Date(value)
            var Y = date.getFullYear() + '年'
            var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '月'
            var D = date.getDate()-1 + '日 '
            var h = date.getHours()+10 + ':'
            var m = date.getMinutes() + ':'
            var s = date.getSeconds()     

            // console.log(date)
            // console.log(Y+M+D+h+m+s);
            return Y+M+D+h+m+s
        },
        async orderDetails(){
            var res ;
            var data ;
            if(this.data.packageId!=null){
                 data = {
                    packageId:this.data.packageId
                }
            }else{
                 data = {
                    picsIds:this.data.picsIds
                }
            }
            res = await orderDetailsApi(data)
            // console.log(res)
            if(res.data.code == 100){
                if(this.data.packageId!=null){
                  this.package =  res.data.data.aPackage 
                }else{
                    this.imgList = res.data.data.pictures
                    this.imgList[0].createDate = this.timestampToTime(this.imgList[0].createDate)
                    // console.log(this.imgList)
                }
            }else{
                alert('请稍后重试')
            }
        }
    }
}
</script>

<style>
.body{
    padding-left: 20px;
}
.img{
    width: 100px;
    height: 80px;
    padding-left: 20px;
    float: left;
}
</style>


// WEBPACK FOOTER //
// src/components/iframe/OrderDetails.vue